import {Action} from '@ngrx/store';
import {type} from '../../shared';


export const companyEditActionTypes = {
  UPDATE: type('[CompanyEdit] Update'),
  UPDATE_SUCCESS: type('[CompanyEdit] Update Success'),
  UPDATE_FAIL: type('[CompanyEdit] Update Fail'),
};

export class CompanyEditAction implements Action {
  readonly type = companyEditActionTypes.UPDATE;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class CompanyEditSuccessAction implements Action {
  readonly type = companyEditActionTypes.UPDATE_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class CompanyEditFailAction implements Action {
  readonly type = companyEditActionTypes.UPDATE_FAIL;
  constructor(public payload?: string) {}
}


